import { create } from 'zustand'
import type { Icon } from '@phosphor-icons/react'

export interface ContextAction {
  id: string
  label: string
  icon?: Icon
  onClick: () => void
  variant?: 'default' | 'primary'
  isActive?: boolean
}

interface HeaderState {
  pageTitle: string | null
  contextActions: ContextAction[]

  setPageTitle: (title: string | null) => void
  setContextActions: (actions: ContextAction[]) => void
  clearContext: () => void
}

export const useHeaderStore = create<HeaderState>((set) => ({
  pageTitle: null,
  contextActions: [],

  setPageTitle: (title) => set({ pageTitle: title }),
  setContextActions: (actions) => set({ contextActions: actions }),
  clearContext: () => set({ pageTitle: null, contextActions: [] }),
}))
